/**
 * @author Cristyan Fernando Ballesteros
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  // 'sidebar.reportes': 'Reportes',
  // 'sidebar.reportegeneral': 'Reporte General',
  // 'sidebar.inventariocoimpresores':'Reporte Inventario Coimpresores',
  // 'sidebar.ReporteInventarioCoimpresores':'Reporte Inventario Coimpresores',
  // 'sidebar.movimientoinventario':'Reporte Movimiento Inventario ',
  // 'sidebar.reportekardex':'Reporte Kardex',
  // 'sidebar.kardex':'Reporte Kardex',
  // 'permiso.reportemovimientoinventario':'Permiso reporte movimiento inventario',
  // 'sidebar.reporteKardex':'Report Kardex',
    'sidebar.estadomaquinas':'Reporte Estado Máquinas',
    'sidebar.reportes': 'Reportes',
    'sidebar.reportegeneral': 'Reporte General',
    'sidebar.inventariocoimpresores': 'Reporte Inventario Coimpresores',
    'sidebar.ReporteInventarioCoimpresores': 'Reporte Inventario Coimpresores',
    'sidebar.reportesabanainformacion': 'Sabana de Información',
    'sidebar.ReporteMovimiento': 'Reporte Movimiento',
    'sidebar.movimiento': 'Reporte Movimiento',
    'sidebar.ReporteSabanaInformacion': 'Reporte Sabana Información',
    'sidebar.movimientoinventario': 'Reporte Movimiento Inventario ',
    'permiso.reportemovimientoinventario': 'Permiso reporte movimiento inventario',
};

